/**
 * Coco Daddy Poster — Product Customizer
 * Theme asset: coco-daddy-poster.js
 *
 * Expects window.CocoDaddyPoster config from the Liquid section.
 */
(function () {
  'use strict';

  const cfg = window.CocoDaddyPoster || {};
  const root = document.getElementById('cocoDaddyPoster');
  if (!root) return;

  const qs = (sel, el = root) => el.querySelector(sel);
  const qsa = (sel, el = root) => [...el.querySelectorAll(sel)];

  const pos = cfg.optionPositions || { people: 1, rush: 2, framing: 3 };
  const variants = (cfg.variants || []).map((v) => ({
    ...v,
    people: String(v[`option${pos.people}`] || ''),
    rush: String(v[`option${pos.rush}`] || ''),
    framing: String(v[`option${pos.framing}`] || ''),
  }));

  const firstPeopleBtn = qs('#peopleOptions .people-btn.active') || qs('#peopleOptions .people-btn');
  const state = {
    step: 1,
    sport: cfg.sport || 'AFL Footy',
    people: cfg.defaultPeople || firstPeopleBtn?.dataset.people || '2',
    photoName: '',
    photoData: '',
    photoFile: null,
    /** Restored Shopify CDN URL — used as cart property until user picks a new file */
    photoCdnUrl: '',
    frame: '',
    product: '',
    size: '',
    rush: false,
    variantId: cfg.variantId || null,
    matchedVariant: null,
    /** Saved-design restore (?mode=order&save_id=…) — review shows Cancel → product page */
    previewMode: false,
  };

  const SAVE_LATER_LABEL = '♡ Save for later';
  const PREVIEW_CANCEL_LABEL = 'Cancel';

  const MAX_UPLOAD_BYTES = 20 * 1024 * 1024;
  const IMAGE_EXT_BY_MIME = {
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'image/webp': '.webp',
    'image/heic': '.heic',
    'image/heif': '.heif',
  };
  const ALLOWED_IMAGE_MIME = new Set(Object.keys(IMAGE_EXT_BY_MIME));
  const ALLOWED_IMAGE_EXT = /\.(jpe?g|png|webp|heic|heif)$/i;
  const HEIC_TO_CDNS = [
    'https://cdn.jsdelivr.net/npm/heic-to@1.5.2/dist/iife/heic-to.js',
    'https://unpkg.com/heic-to@1.5.2/dist/iife/heic-to.js',
  ];
  let heicPreviewObjectUrl = null;
  const FIELD_LABELS = {
    rugby_team: 'Please choose a Rugby Team.',
    afl_team: 'Please choose an AFL Team.',
    football_team: 'Please choose a Football Team.',
    stadium: `Please select a ${cfg.stadiumLabel || root.dataset.stadiumLabel || 'Background'}.`,
    names: 'Please enter Names.',
    est: 'Please enter EST Date (or N/A).',
    message: 'Please enter a special message.',
    upload: 'Please upload your photo before continuing.',
    people: 'Please select the number of people.',
    product: 'Please choose a product type.',
    size: 'Please choose a size.',
    frame: 'Please choose a frame colour.',
    variant: 'Selected options are unavailable. Please choose another finish.',
    bg_colour: 'Please select a Background colour.',
    style: 'Please choose a Style.',
    dad_name: 'Please enter Name for Dad.',
  };

  const FIELD_CFG = {};
  const fieldsSource = cfg.fieldsList || root.dataset.fields || '';
  String(fieldsSource)
    .split(',')
    .forEach((part) => {
      const trimmed = part.trim();
      if (!trimmed) return;
      const [key, mode = 'opt'] = trimmed.split(':');
      if (key) FIELD_CFG[key] = { mode };
    });

  function isFieldActive(key) {
    return !!FIELD_CFG[key];
  }

  function isFieldRequired(key) {
    return FIELD_CFG[key] && FIELD_CFG[key].mode === 'req';
  }

  function getFieldWrap(key) {
    return qs(`[data-coco-field="${key}"]`);
  }

  function setErrorState(el, invalid) {
    if (!el) return;
    el.classList.toggle('is-invalid', !!invalid);
    const field = el.closest?.('.field, [data-coco-field], .preview-upload, .people-options, .product-types, .size-options, .frame-options');
    if (field) field.classList.toggle('is-invalid', !!invalid);
  }

  function clearStepErrors(step) {
    const box = qs(`#step${step}Errors`);
    if (box) {
      box.hidden = true;
      box.textContent = '';
    }
    qsa('.is-invalid').forEach((el) => el.classList.remove('is-invalid'));
    const uploadErr = qs('#uploadError');
    if (uploadErr) {
      uploadErr.hidden = true;
      uploadErr.textContent = '';
    }
  }

  function showStepErrors(step, errors, firstInvalid) {
    const box = qs(`#step${step}Errors`);
    if (box) {
      box.hidden = false;
      box.textContent = errors.join(' ');
    }
    showToast(errors[0] || 'Please complete the required fields.');
    if (firstInvalid && typeof firstInvalid.scrollIntoView === 'function') {
      try {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {
        firstInvalid.scrollIntoView();
      }
    }
  }

  const moneyCents = (cents) => {
    const value = Number(cents) || 0;
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && cfg.moneyFormat) {
      return Shopify.formatMoney(value, cfg.moneyFormat);
    }
    return `$${(value / 100).toFixed(2)}`;
  };

  function classifyFraming(framingValue) {
    const raw = String(framingValue || '');
    const v = raw.toLowerCase();
    const result = { type: null, size: null, colour: null, raw };
    if (v.includes('digital') || v.includes('no frame')) {
      result.type = 'digital';
      return result;
    }
    if (v.includes('oak')) result.colour = 'Oak';
    else if (v.includes('black')) result.colour = 'Black';
    else if (v.includes('white')) result.colour = 'White';

    if (v.includes('45') && v.includes('60')) result.size = '4560';
    else if (v.includes('30') && v.includes('40')) result.size = '3040';

    if (v.includes('unframed') || (v.includes('print') && !v.includes('frame')) || v.includes('matte')) {
      result.type = 'print';
      return result;
    }
    if (v.includes('frame') || result.colour) {
      result.type = 'framed';
      return result;
    }
    return result;
  }

  function isNoRush(value) {
    const v = String(value || '').toLowerCase();
    return !v || v.includes('no thanks') || v === 'no' || v.includes('standard');
  }

  function rushValueForState() {
    const rushes = cfg.rushes || [];
    if (!state.rush) {
      return (
        rushes.find((r) => isNoRush(r)) ||
        cfg.defaultRush ||
        'No thanks'
      );
    }
    return (
      rushes.find((r) => !isNoRush(r)) ||
      rushes[0] ||
      cfg.defaultRush ||
      'No thanks'
    );
  }

  function sizeKeyFromState() {
    return state.size === '45x60cm' ? '4560' : '3040';
  }

  function colourFromState() {
    return { natural: 'Oak', black: 'Black', white: 'White', none: null }[state.frame] || 'Oak';
  }

  function framingMatches(c) {
    if (state.product === 'digital') return c.type === 'digital';
    if (state.product === 'print') {
      return c.type === 'print' && (!c.size || c.size === sizeKeyFromState());
    }
    return (
      c.type === 'framed' &&
      (!c.size || c.size === sizeKeyFromState()) &&
      (!c.colour || c.colour === colourFromState())
    );
  }

  function findVariant(overrides = {}) {
    const people = String(overrides.people ?? state.people);
    const rush = String(overrides.rush ?? rushValueForState());
    const product = overrides.product ?? state.product;
    const size = overrides.size ?? state.size;
    const frame = overrides.frame ?? state.frame;

    if (!product) return null;
    if (product !== 'digital' && !size) return null;
    if (product === 'frame' && (!frame || frame === 'none')) return null;

    const wantSize = size === '45x60cm' ? '4560' : '3040';
    const wantColour = { natural: 'Oak', black: 'Black', white: 'White' }[frame] || null;
    if (product === 'frame' && !wantColour) return null;

    const pool = variants.filter((rec) => {
      if (people && rec.people && String(rec.people).trim() !== people.trim()) return false;
      if (rush && rec.rush && String(rec.rush).trim() !== String(rush).trim()) return false;
      const c = classifyFraming(rec.framing);
      if (product === 'digital') return c.type === 'digital';
      if (product === 'print') return c.type === 'print' && (!c.size || c.size === wantSize);
      return (
        c.type === 'framed' &&
        (!c.size || c.size === wantSize) &&
        (!c.colour || c.colour === wantColour)
      );
    });

    return (
      pool.find((v) => v.available) ||
      pool[0] ||
      null
    );
  }

  function isVariantAvailable(overrides = {}) {
    const matched = findVariant(overrides);
    return !!(matched && matched.available);
  }

  function isProductTypeAvailable(product) {
    if (product === 'digital') {
      return isVariantAvailable({ product: 'digital', frame: 'none' });
    }
    if (product === 'print') {
      return (
        isVariantAvailable({ product: 'print', size: '30x40cm', frame: 'none' }) ||
        isVariantAvailable({ product: 'print', size: '45x60cm', frame: 'none' })
      );
    }
    return ['30x40cm', '45x60cm'].some((size) =>
      ['natural', 'black', 'white'].some((frame) =>
        isVariantAvailable({ product: 'frame', size, frame })
      )
    );
  }

  function isSizeAvailable(size) {
    if (!state.product || state.product === 'digital') {
      return (
        isVariantAvailable({ product: 'print', size, frame: 'none' }) ||
        ['natural', 'black', 'white'].some((frame) =>
          isVariantAvailable({ product: 'frame', size, frame })
        )
      );
    }
    if (state.product === 'print') {
      return isVariantAvailable({ product: 'print', size, frame: 'none' });
    }
    return ['natural', 'black', 'white'].some((frame) =>
      isVariantAvailable({ product: 'frame', size, frame })
    );
  }

  function isFrameColourAvailable(frame) {
    return isVariantAvailable({
      product: 'frame',
      size: state.size || '30x40cm',
      frame,
    });
  }

  function currentVariant() {
    if (!state.product) return null;
    if (state.product !== 'digital' && !state.size) return null;
    if (state.product === 'frame' && (!state.frame || state.frame === 'none')) return null;
    return findVariant();
  }

  /** Best price for current people/rush (and framing when complete). */
  function displayVariant() {
    const matched = currentVariant();
    if (matched) return matched;

    const people = String(state.people || '');
    const rush = String(rushValueForState());
    const pool = variants.filter((rec) => {
      if (people && rec.people && String(rec.people) !== people) return false;
      if (rush && rec.rush && String(rec.rush) !== rush) return false;
      return true;
    });

    const list = (pool.length ? pool : variants).filter((v) => v.available);
    const candidates = list.length ? list : pool.length ? pool : variants;
    if (!candidates.length) return null;

    return candidates.reduce((best, v) => {
      const p = Number(v.price) || 0;
      const b = Number(best.price) || 0;
      return p < b ? v : best;
    }, candidates[0]);
  }

  function totalCents() {
    const v = displayVariant();
    return v ? Number(v.price) || 0 : 0;
  }

  function compareCents() {
    const v = displayVariant();
    const compare = Number(v?.compare_at_price) || 0;
    const price = Number(v?.price) || 0;
    return compare > price ? compare : 0;
  }

  /* ---------- UI helpers ---------- */

  function showToast(message) {
    const toast = qs('#toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toast.classList.remove('show'), 2600);
  }

  function updateOptionPriceLabels() {
    const digital = findVariant({ product: 'digital', frame: 'none' });
    const print = findVariant({ product: 'print', size: '30x40cm', frame: 'none' });
    const selectedFrame = state.frame === 'none' ? 'natural' : state.frame;
    const framedSelected = findVariant({
      product: 'frame',
      size: state.size || '30x40cm',
      frame: selectedFrame,
    });
    const framedDefault = findVariant({ product: 'frame', size: '30x40cm', frame: 'natural' });
    const sizeProduct = state.product === 'digital' ? 'print' : state.product;
    const size3040 = findVariant({
      product: sizeProduct,
      size: '30x40cm',
      frame: sizeProduct === 'frame' ? selectedFrame : 'none',
    });
    const size4560 = findVariant({
      product: sizeProduct,
      size: '45x60cm',
      frame: sizeProduct === 'frame' ? selectedFrame : 'none',
    });
    const frameOak = findVariant({ product: 'frame', size: state.size || '30x40cm', frame: 'natural' });
    const frameBlack = findVariant({ product: 'frame', size: state.size || '30x40cm', frame: 'black' });
    const frameWhite = findVariant({ product: 'frame', size: state.size || '30x40cm', frame: 'white' });

    const setLabel = (key, cents, available = true) => {
      const el = qs(`[data-price-label="${key}"]`);
      if (!el) return;
      if (!available) {
        el.textContent = 'Not available';
        return;
      }
      el.textContent = cents != null ? moneyCents(cents) : '—';
    };

    const digitalOk = isProductTypeAvailable('digital');
    const printOk = isProductTypeAvailable('print');
    const frameOk = isProductTypeAvailable('frame');
    const size3040Ok = isSizeAvailable('30x40cm');
    const size4560Ok = isSizeAvailable('45x60cm');
    const oakOk = isFrameColourAvailable('natural');
    const blackOk = isFrameColourAvailable('black');
    const whiteOk = isFrameColourAvailable('white');

    setLabel('digital', digital?.price, digitalOk);
    setLabel('print', print?.price, printOk);
    setLabel('frame', (framedSelected || framedDefault)?.price, frameOk);
    setLabel('size-3040', size3040?.price, size3040Ok);
    setLabel('size-4560', size4560?.price, size4560Ok);
    setLabel('frame-natural', frameOak?.price, oakOk);
    setLabel('frame-black', frameBlack?.price, blackOk);
    setLabel('frame-white', frameWhite?.price, whiteOk);

    const markBtn = (el, available) => {
      if (!el) return;
      el.classList.toggle('is-unavailable', !available);
      el.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (!available) el.classList.remove('selected', 'active');
    };

    qsa('#productTypes .product-type').forEach((btn) => {
      markBtn(btn, isProductTypeAvailable(btn.dataset.product));
      btn.classList.toggle('selected', btn.dataset.product === state.product && isProductTypeAvailable(state.product));
    });
    qsa('#sizeOptions .size-btn').forEach((btn) => {
      markBtn(btn, isSizeAvailable(btn.dataset.size));
      btn.classList.toggle('active', btn.dataset.size === state.size && isSizeAvailable(state.size));
    });
    qsa('#frameOptions .frame-card').forEach((btn) => {
      markBtn(btn, isFrameColourAvailable(btn.dataset.frame));
      btn.classList.toggle('selected', btn.dataset.frame === state.frame && isFrameColourAvailable(state.frame));
    });

    const rushOff = findVariant({ rush: cfg.defaultRush || (cfg.rushes || []).find(isNoRush) });
    const rushOnVal = (cfg.rushes || []).find((r) => !isNoRush(r));
    const rushOn = rushOnVal ? findVariant({ rush: rushOnVal }) : null;
    const rushDelta =
      rushOn && rushOff ? Math.max(0, Number(rushOn.price) - Number(rushOff.price)) : 0;
    qsa('[data-rush-label]').forEach((el) => {
      el.textContent = rushDelta ? `+${moneyCents(rushDelta)}` : '';
    });
    const rushCard = qs('#rushCard');
    if (rushCard) rushCard.hidden = !rushOnVal || !rushDelta;
  }

  let framingEnsureLock = false;
  function ensureValidFramingSelection() {
    if (framingEnsureLock) return;
    framingEnsureLock = true;
    try {
      // Only clear invalid selections — never auto-pick a default on load
      if (state.product && !isProductTypeAvailable(state.product)) {
        state.product = '';
        state.size = '';
        state.frame = '';
        const sizeSection = qs('#sizeSection');
        const frameSection = qs('#frameColourSection');
        if (sizeSection) sizeSection.hidden = true;
        if (frameSection) frameSection.hidden = true;
        qsa('#productTypes .product-type').forEach((btn) => btn.classList.remove('selected'));
        qsa('#sizeOptions .size-btn').forEach((btn) => btn.classList.remove('active'));
        qsa('.frame-card').forEach((card) => card.classList.remove('selected'));
        return;
      }

      if (state.product && state.product !== 'digital' && state.size && !isSizeAvailable(state.size)) {
        state.size = '';
        qsa('#sizeOptions .size-btn').forEach((btn) => btn.classList.remove('active'));
        const sizeSelect = qs('#sizeSelect');
        if (sizeSelect) sizeSelect.value = '';
      }

      if (state.product === 'frame' && state.frame && state.frame !== 'none' && !isFrameColourAvailable(state.frame)) {
        state.frame = '';
        qsa('.frame-card').forEach((card) => card.classList.remove('selected'));
      }
    } finally {
      framingEnsureLock = false;
    }
  }

  function updateVariantUrl(variantId) {
    if (!variantId) return;
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get('variant') === String(variantId)) return;
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({ variant: String(variantId) }, '', url.toString());
    } catch (e) {
      // Ignore URL update failures.
    }
  }

  function syncVariantIdInputs(variantId) {
    if (!variantId) return;
    const id = String(variantId);
    const variantInput = qs('#variantIdInput');
    if (variantInput) variantInput.value = id;

    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
      input.value = id;
    });
  }

  function updateTotal() {
    ensureValidFramingSelection();

    const matched = currentVariant();
    state.matchedVariant = matched;
    state.variantId = matched?.id || null;

    if (state.variantId) {
      syncVariantIdInputs(state.variantId);
      updateVariantUrl(state.variantId);
    }

    const price = totalCents();
    const compare = compareCents();
    const save = compare > price ? compare - price : 0;

    qsa('[data-current-total]').forEach((el) => (el.textContent = moneyCents(price)));
    qsa('[data-was-total]').forEach((el) => {
      el.textContent = compare ? moneyCents(compare) : '';
      el.style.display = compare ? '' : 'none';
    });
    qsa('[data-savings]').forEach((el) => {
      el.textContent = save ? `You save ${moneyCents(save)}` : '';
      el.style.display = save ? '' : 'none';
    });

    const productPrice = qs('[data-product-price]');
    if (productPrice) productPrice.textContent = moneyCents(price);

    const productCompare = qs('[data-product-compare]');
    if (productCompare) {
      productCompare.textContent = compare ? moneyCents(compare) : '';
      productCompare.style.display = compare ? '' : 'none';
    }
    const saveBadge = qs('.price-line .save-badge');
    if (saveBadge) {
      if (compare > price) {
        const pct = Math.round(((compare - price) / compare) * 100);
        saveBadge.textContent = `Save ${pct}%`;
        saveBadge.style.display = '';
      } else {
        saveBadge.style.display = 'none';
      }
    }

    updateOptionPriceLabels();
    updateBreakdown();
    syncHiddenFields();
  }

  function setStep(step, { skipValidation = false } = {}) {
    if (!skipValidation && step > state.step) {
      const result = validateStep(state.step);
      if (!result.ok) {
        showStepErrors(state.step, result.errors, result.firstInvalid);
        return false;
      }
      clearStepErrors(state.step);
    }

    state.step = step;
    root.classList.toggle('wizard-framing', step === 2);
    root.classList.toggle('wizard-review', step === 3);
    root.classList.toggle('wizard-personalise', step === 1);
    qsa('.wizard-step').forEach((panel) => {
      panel.hidden = Number(panel.dataset.step) !== step;
    });
    qsa('[data-step-nav]').forEach((item) => {
      const n = Number(item.dataset.stepNav);
      item.classList.toggle('active', n === step);
      item.classList.toggle('done', n < step);
      const num = item.querySelector('.num');
      if (num) num.textContent = n < step ? '✓' : n;
    });
    qsa('[data-line]').forEach((line) => {
      line.classList.toggle('done', Number(line.dataset.line) < step);
    });
    if (step === 3) updateReview();
    const wizard = qs('#wizard');
    if (root.classList.contains('wizard-open') && wizard) {
      wizard.scrollTop = 0;
    } else {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    return true;
  }

  function validateStep(step) {
    const errors = [];
    let firstInvalid = null;

    const mark = (el, message) => {
      setErrorState(el, true);
      if (!firstInvalid && el) firstInvalid = el;
      errors.push(message);
    };

    if (step === 1) {
      if (!state.people) {
        mark(qs('#peopleOptions'), FIELD_LABELS.people);
      }

      const teamKey = cfg.teamKey || root.dataset.teamKey || 'afl_team';
      if (isFieldRequired(teamKey) || (isFieldRequired('rugby_team') || isFieldRequired('afl_team') || isFieldRequired('football_team'))) {
        const teamInput = qs('#teamInput');
        if (teamInput && (teamInput.dataset.required === 'true' || teamInput.required || isFieldRequired(teamKey))) {
          const hasTeam = String(teamInput.value || '').trim() !== '';
          setErrorState(teamInput, !hasTeam);
          if (!hasTeam) mark(teamInput, FIELD_LABELS[teamKey] || 'Please choose a team.');
        }
      }

      if (isFieldRequired('stadium')) {
        const bgInput = qs('#backgroundInput');
        const stadiumWrap = getFieldWrap('stadium');
        const hasBg = String(bgInput?.value || '').trim() !== '';
        setErrorState(stadiumWrap || bgInput, !hasBg);
        if (!hasBg) mark(stadiumWrap || bgInput, FIELD_LABELS.stadium);
      }

      if (isFieldRequired('bg_colour')) {
        const bgColourInput = qs('#bgColourInput');
        const wrap = getFieldWrap('bg_colour');
        const hasColour = String(bgColourInput?.value || '').trim() !== '';
        setErrorState(wrap || bgColourInput, !hasColour);
        if (!hasColour) mark(wrap || bgColourInput, FIELD_LABELS.bg_colour);
      }

      if (isFieldRequired('style')) {
        const styleInput = qs('#styleInput');
        const wrap = getFieldWrap('style');
        const hasStyle = String(styleInput?.value || '').trim() !== '';
        setErrorState(wrap || styleInput, !hasStyle);
        if (!hasStyle) mark(wrap || styleInput, FIELD_LABELS.style);
      }

      if (isFieldRequired('dad_name')) {
        const dadInput = qs('#dadNameInput');
        if (dadInput) {
          const hasDad = String(dadInput.value || '').trim() !== '';
          setErrorState(dadInput, !hasDad);
          if (!hasDad) mark(dadInput, FIELD_LABELS.dad_name);
        }
      }

      if (isFieldRequired('names')) {
        const namesInput = qs('#posterTitleInput');
        if (namesInput) {
          const hasNames = String(namesInput.value || '').trim() !== '';
          setErrorState(namesInput, !hasNames);
          if (!hasNames) mark(namesInput, FIELD_LABELS.names);
        }
      }

      if (isFieldRequired('est')) {
        const estInput = qs('#estYear');
        if (estInput) {
          const hasEst = String(estInput.value || '').trim() !== '';
          setErrorState(estInput, !hasEst);
          if (!hasEst) mark(estInput, FIELD_LABELS.est);
        }
      }

      if (isFieldRequired('message')) {
        const messageInput = qs('#messageInput');
        if (messageInput) {
          const hasMessage = String(messageInput.value || '').trim() !== '';
          setErrorState(messageInput, !hasMessage);
          if (!hasMessage) mark(messageInput, FIELD_LABELS.message);
        }
      }

      if (isFieldRequired('upload') || cfg.requirePhoto !== false) {
        const hasUpload = !!(state.photoFile || state.photoName || state.photoData || state.photoCdnUrl);
        const uploadWrap = qs('#uploadBox') || qs('#mobileUploadBox') || getFieldWrap('upload');
        setErrorState(uploadWrap, !hasUpload);
        if (uploadWrap) uploadWrap.classList.toggle('coco-upload-invalid', !hasUpload);
        if (!hasUpload) mark(uploadWrap, FIELD_LABELS.upload);
      }
    }

    if (step === 2) {
      if (!state.product) {
        mark(qs('#productTypes'), FIELD_LABELS.product);
      } else {
        if (state.product !== 'digital' && !state.size) {
          mark(qs('#sizeOptions'), FIELD_LABELS.size);
        }
        if (state.product === 'frame' && (!state.frame || state.frame === 'none')) {
          mark(qs('#frameOptions'), FIELD_LABELS.frame);
        }
        const framingComplete =
          state.product === 'digital' ||
          (state.product === 'print' && state.size) ||
          (state.product === 'frame' && state.size && state.frame && state.frame !== 'none');
        if (framingComplete) {
          const matched = currentVariant();
          if (!matched || matched.available === false) {
            mark(qs('#productTypes'), FIELD_LABELS.variant);
          }
        }
      }
    }

    if (step === 3) {
      const step1 = validateStep(1);
      const step2 = validateStep(2);
      if (!step1.ok) {
        return { ok: false, errors: step1.errors, firstInvalid: step1.firstInvalid, goTo: 1 };
      }
      if (!step2.ok) {
        return { ok: false, errors: step2.errors, firstInvalid: step2.firstInvalid, goTo: 2 };
      }
    }

    return { ok: errors.length === 0, errors, firstInvalid };
  }

  function setWizardScrollLock(locked) {
    const mobile = window.matchMedia('(max-width: 720px)').matches;
    const shouldLock = locked && mobile;
    document.documentElement.classList.toggle('coco-wizard-lock', shouldLock);
    document.body.classList.toggle('coco-wizard-lock', shouldLock);
    if (!shouldLock) {
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    }
  }

  function openWizard() {
    const wizard = qs('#wizard');
    root.classList.add('wizard-open');
    setWizardScrollLock(true);
    wizard.hidden = false;
    wizard.classList.add('open');
    wizard.setAttribute('aria-hidden', 'false');
    setStep(1, { skipValidation: true });
    clearStepErrors(1);
    clearStepErrors(2);
    wizard.scrollTop = 0;
  }

  function closeWizard() {
    const wizard = qs('#wizard');
    root.classList.remove('wizard-open');
    setWizardScrollLock(false);
    wizard.classList.remove('open');
    wizard.hidden = true;
    wizard.setAttribute('aria-hidden', 'true');
  }

  /* ---------- Photo upload ---------- */

  function humanSize(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(0)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
  }

  function clearPhoto() {
    state.photoFile = null;
    state.photoData = '';
    state.photoName = '';
    state.photoCdnUrl = '';
    window.__cocoUploadedFile = null;
    clearHeicPreviewUrl();
    setPreviewLoading(false);

    const photoUpload = qs('#photoUpload');
    if (photoUpload) photoUpload.value = '';

    const livePreview = qs('#livePreview');
    const previewCard = qs('#previewCard');
    const mobileUpload = qs('#mobileUpload');
    livePreview?.classList.remove('has-photo');
    livePreview?.classList.add('has-upload');
    previewCard?.classList.remove('has-photo');
    mobileUpload?.classList.remove('has-photo');

    qsa('[data-uploaded-photo]').forEach((img) => img.removeAttribute('src'));
    qsa('[data-poster-paper]').forEach((p) => p.classList.remove('has-photo'));

    const empty = qs('#uploadEmpty');
    const filled = qs('#uploadFilled');
    const mobileEmpty = qs('#mobileUploadEmpty');
    const mobileFilled = qs('#mobileUploadFilled');
    if (empty) empty.hidden = false;
    if (filled) filled.hidden = true;
    if (mobileEmpty) mobileEmpty.hidden = false;
    if (mobileFilled) mobileFilled.hidden = true;

    const fileStatus = qs('#fileStatus');
    if (fileStatus) fileStatus.textContent = 'No image selected';
    const uploadErr = qs('#uploadError');
    if (uploadErr) {
      uploadErr.hidden = true;
      uploadErr.textContent = '';
    }
    qs('#uploadBox')?.classList.remove('coco-upload-invalid', 'is-invalid');
    qs('#mobileUploadBox')?.classList.remove('coco-upload-invalid', 'is-invalid');
    syncHiddenFields();
  }

  function setPreviewLoading(loading) {
    const on = !!loading;
    root.classList.toggle('is-preview-loading', on);
    qsa('#uploadThumb, #mobileUploadThumb, [data-uploaded-photo]').forEach((img) => {
      img.classList.toggle('is-skeleton', on);
    });
    qsa('[data-poster-paper]').forEach((p) => p.classList.toggle('is-preview-loading', on));
    qsa('.upload-check').forEach((el) => {
      el.classList.toggle('is-loading', on);
      el.textContent = on ? 'Loading…' : 'Ready ✓';
    });
  }

  function setPreviewImages(src) {
    const targets = [
      ...qsa('[data-uploaded-photo]'),
      qs('#uploadThumb'),
      qs('#mobileUploadThumb'),
    ].filter(Boolean);

    if (!src) {
      targets.forEach((img) => {
        img.onload = null;
        img.onerror = null;
        img.removeAttribute('src');
      });
      return;
    }

    setPreviewLoading(true);
    let pending = targets.length;
    const done = () => {
      pending -= 1;
      if (pending <= 0) setPreviewLoading(false);
    };

    targets.forEach((img) => {
      img.onload = () => {
        img.onload = null;
        img.onerror = null;
        done();
      };
      img.onerror = () => {
        img.onload = null;
        img.onerror = null;
        done();
      };
      img.src = src;
      if (img.complete && img.naturalWidth > 0) {
        img.onload = null;
        img.onerror = null;
        done();
      }
    });
  }

  function applyPhoto(data, name, file) {
    state.photoData = data || '';
    state.photoName = name;
    state.photoFile = file || null;
    window.__cocoUploadedFile = file || null;

    // New file upload → cart gets the file (Shopify CDN). Restored https URL → cart property.
    if (file) {
      state.photoCdnUrl = '';
    } else if (typeof data === 'string' && /^https?:\/\//i.test(data)) {
      state.photoCdnUrl = data;
    } else {
      state.photoCdnUrl = '';
    }

    setPreviewImages(data);
    qsa('[data-poster-paper]').forEach((p) => p.classList.add('has-photo'));

    const livePreview = qs('#livePreview');
    const previewCard = qs('#previewCard');
    const mobileUpload = qs('#mobileUpload');
    livePreview?.classList.add('has-photo');
    livePreview?.classList.remove('has-upload');
    previewCard?.classList.add('has-photo');
    mobileUpload?.classList.add('has-photo');

    const empty = qs('#uploadEmpty');
    const filled = qs('#uploadFilled');
    if (empty) empty.hidden = true;
    if (filled) filled.hidden = false;
    const uploadName = qs('#uploadName');
    if (uploadName) uploadName.textContent = name;
    const uploadSize = qs('#uploadSize');
    if (uploadSize) uploadSize.textContent = file ? humanSize(file.size) : '';

    const mobileEmpty = qs('#mobileUploadEmpty');
    const mobileFilled = qs('#mobileUploadFilled');
    if (mobileEmpty) mobileEmpty.hidden = true;
    if (mobileFilled) mobileFilled.hidden = false;
    const mobileName = qs('#mobileUploadName');
    if (mobileName) mobileName.textContent = name;

    const fileStatus = qs('#fileStatus');
    if (fileStatus) {
      fileStatus.textContent = file
        ? `${name} uploaded successfully`
        : state.photoCdnUrl
          ? 'Saved photo restored'
          : `${name} uploaded successfully`;
    }
    const uploadErr = qs('#uploadError');
    if (uploadErr) {
      uploadErr.hidden = true;
      uploadErr.textContent = '';
    }
    qs('#uploadBox')?.classList.remove('coco-upload-invalid', 'is-invalid');
    qs('#mobileUploadBox')?.classList.remove('coco-upload-invalid', 'is-invalid');
    syncHiddenFields();
  }

  function showUploadError(msg) {
    const uploadErr = qs('#uploadError');
    if (uploadErr) {
      uploadErr.hidden = false;
      uploadErr.textContent = msg;
    }
    qs('#uploadBox')?.classList.add('coco-upload-invalid', 'is-invalid');
    qs('#mobileUploadBox')?.classList.add('coco-upload-invalid', 'is-invalid');
    showToast(msg);
  }

  function setFileStatus(text) {
    const fileStatus = qs('#fileStatus');
    if (fileStatus) fileStatus.textContent = text;
  }

  function clearHeicPreviewUrl() {
    if (heicPreviewObjectUrl) {
      try {
        URL.revokeObjectURL(heicPreviewObjectUrl);
      } catch (_) {
        /* ignore */
      }
      heicPreviewObjectUrl = null;
    }
  }

  function isAllowedImageFile(file) {
    const type = String(file.type || '');
    const name = String(file.name || '');
    if (/^image\//i.test(type)) return true;
    if (ALLOWED_IMAGE_MIME.has(type.toLowerCase())) return true;
    return ALLOWED_IMAGE_EXT.test(name);
  }

  function isHeicOrHeif(file) {
    if (!file) return false;
    return (
      /^(image\/heic|image\/heif)$/i.test(file.type) || /\.(heic|heif)$/i.test(file.name || '')
    );
  }

  // Same approach as coco-photo-upload: load heic-to from CDN only (no theme asset).
  function loadHeicConverter(done) {
    if (typeof window.HeicTo === 'function') {
      done(null, window.HeicTo);
      return;
    }
    const existing = document.querySelector('script[data-coco-heic-to]');
    if (existing) {
      const wait = () => {
        if (typeof window.HeicTo === 'function') done(null, window.HeicTo);
        else done(new Error('HeicTo missing after load'));
      };
      existing.addEventListener('load', wait);
      existing.addEventListener('error', () => done(new Error('heic-to failed to load')));
      return;
    }
    let i = 0;
    function tryNext() {
      if (i >= HEIC_TO_CDNS.length) {
        done(new Error('heic-to failed to load'));
        return;
      }
      const s = document.createElement('script');
      s.src = HEIC_TO_CDNS[i++];
      s.async = true;
      s.setAttribute('data-coco-heic-to', '1');
      s.onload = () => {
        if (typeof window.HeicTo === 'function') done(null, window.HeicTo);
        else tryNext();
      };
      s.onerror = () => {
        try {
          s.remove();
        } catch (_) {
          /* ignore */
        }
        tryNext();
      };
      document.head.appendChild(s);
    }
    tryNext();
  }

  function setThumbFromBlob(blob) {
    clearHeicPreviewUrl();
    heicPreviewObjectUrl = URL.createObjectURL(blob);
    state.photoData = heicPreviewObjectUrl;
    setPreviewImages(heicPreviewObjectUrl);
    setFileStatus(`${state.photoName} uploaded successfully`);
  }

  function markHeicPreviewUnavailable() {
    setPreviewLoading(false);
    setFileStatus('HEIC ready — preview unavailable');
  }

  function convertHeicPreview(file) {
    loadHeicConverter((err, HeicTo) => {
      if (err || typeof HeicTo !== 'function') {
        markHeicPreviewUnavailable();
        return;
      }
      Promise.resolve(
        HeicTo({
          blob: file,
          type: 'image/jpeg',
          quality: 0.8,
        })
      )
        .then((result) => {
          const blob = Array.isArray(result) ? result[0] : result;
          if (!blob) throw new Error('empty conversion');
          setThumbFromBlob(blob);
        })
        .catch(() => {
          markHeicPreviewUnavailable();
        });
    });
  }

  function setHeicPreview(file) {
    clearHeicPreviewUrl();
    setPreviewImages('');
    setPreviewLoading(true);
    setFileStatus('Generating preview…');

    // Probe native decode first (Safari). If it fails, convert via CDN heic-to.
    const nativeUrl = URL.createObjectURL(file);
    const probe = new Image();
    let settled = false;
    const timer = setTimeout(() => {
      if (settled) return;
      settled = true;
      try {
        URL.revokeObjectURL(nativeUrl);
      } catch (_) {
        /* ignore */
      }
      convertHeicPreview(file);
    }, 600);

    probe.onload = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      clearHeicPreviewUrl();
      heicPreviewObjectUrl = nativeUrl;
      state.photoData = nativeUrl;
      setPreviewImages(nativeUrl);
      setFileStatus(`${file.name} uploaded successfully`);
    };
    probe.onerror = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      try {
        URL.revokeObjectURL(nativeUrl);
      } catch (_) {
        /* ignore */
      }
      convertHeicPreview(file);
    };
    probe.src = nativeUrl;
  }

  function readFileAsDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error('Could not read that image. Please try another file.'));
      reader.readAsDataURL(file);
    });
  }

  async function handleFile(file) {
    if (!file) {
      clearPhoto();
      return;
    }
    if (!isAllowedImageFile(file)) {
      clearPhoto();
      showUploadError('Please upload an image file (JPG, PNG, WEBP, HEIC or HEIF).');
      return;
    }
    if (file.size > MAX_UPLOAD_BYTES) {
      clearPhoto();
      showUploadError('That image is over 20MB. Please upload a smaller file.');
      return;
    }

    // Accept the file immediately (same as coco-photo-upload). Preview is best-effort.
    clearHeicPreviewUrl();
    applyPhoto('', file.name, file);
    setPreviewLoading(true);
    setFileStatus(isHeicOrHeif(file) ? 'Generating preview…' : 'Loading preview…');

    if (isHeicOrHeif(file)) {
      setHeicPreview(file);
      return;
    }

    try {
      const previewData = await readFileAsDataUrl(file);
      applyPhoto(previewData, file.name, file);
    } catch (err) {
      // File is still kept for cart upload even if local preview fails.
      setPreviewLoading(false);
      setFileStatus(`${file.name} ready — preview unavailable`);
      console.warn(err);
    }
  }

  /* ---------- Framing / product ---------- */

  function frameLabel() {
    return (
      { none: 'No frame', natural: 'Oak', black: 'Black', white: 'White' }[state.frame] || 'Not selected'
    );
  }

  function productLabel() {
    return (
      {
        digital: 'Digital download',
        print: 'Premium matte print',
        frame: 'Framed print',
      }[state.product] || 'Not selected'
    );
  }

  function updateMobileFramePreview() {
    const caption = qs('#mobileFrameCaption');
    if (!caption) return;
    if (state.product === 'frame' && state.frame !== 'none') {
      caption.textContent = `${frameLabel()} frame · your photo`;
    } else if (state.product === 'digital') {
      caption.textContent = 'Digital download preview';
    } else {
      caption.textContent = 'Premium matte print preview';
    }
  }

  function setFrame(frame) {
    if (frame && frame !== 'none' && !isFrameColourAvailable(frame)) return;
    state.frame = frame === 'none' ? 'none' : frame || '';
    if (frame && frame !== 'none') {
      qsa('[data-poster-frame]').forEach((el) => {
        el.className = 'poster-frame';
        el.classList.add(`frame-${frame}`);
      });
    }
    qsa('.frame-card').forEach((card) =>
      card.classList.toggle(
        'selected',
        !!frame && frame !== 'none' && card.dataset.frame === frame && !card.classList.contains('is-unavailable')
      )
    );
    updateMobileFramePreview();
    updateTotal();
  }

  function updateSizeSectionCopy() {
    const isFramed = state.product === 'frame';
    const label = isFramed ? 'Frame Size' : 'Print Size';
    const title = qs('#sizeSectionTitle');
    const helper = qs('#sizeSectionHelper');
    const reviewLabel = qs('#reviewSizeLabel');
    if (title) title.textContent = label;
    if (helper) {
      helper.textContent = isFramed
        ? 'Select the size of your framed artwork.'
        : 'Select the size of your printed artwork.';
    }
    if (reviewLabel && state.product !== 'digital') reviewLabel.textContent = label;
  }

  function setProduct(product) {
    if (!isProductTypeAvailable(product)) return;
    state.product = product;
    qsa('#productTypes .product-type').forEach((btn) => {
      btn.classList.toggle('selected', btn.dataset.product === product && !btn.classList.contains('is-unavailable'));
    });

    const isDigital = product === 'digital';
    const isFramed = product === 'frame';
    const sizeSection = qs('#sizeSection');
    const frameSection = qs('#frameColourSection');
    if (sizeSection) sizeSection.hidden = isDigital;
    if (frameSection) frameSection.hidden = !isFramed;

    // Reset size, then default-select first available print size for print/frame
    state.size = '';
    qsa('#sizeOptions .size-btn').forEach((btn) => btn.classList.remove('active'));
    const sizeSelect = qs('#sizeSelect');
    if (sizeSelect) sizeSelect.value = '';

    if (!isDigital) {
      const defaultSize = ['30x40cm', '45x60cm'].find((s) => isSizeAvailable(s));
      if (defaultSize) setSize(defaultSize);
    }

    if (isFramed) {
      const oak = isFrameColourAvailable('natural')
        ? 'natural'
        : ['natural', 'black', 'white'].find((f) => isFrameColourAvailable(f));
      if (oak) setFrame(oak);
      else {
        state.frame = '';
        qsa('.frame-card').forEach((card) => card.classList.remove('selected'));
        updateMobileFramePreview();
        updateTotal();
      }
    } else {
      setFrame('none');
    }
    updateSizeSectionCopy();
  }

  function setSize(size) {
    if (!isSizeAvailable(size)) return;
    state.size = size;
    qsa('#sizeOptions .size-btn').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.size === size && !btn.classList.contains('is-unavailable'));
    });
    const sizeSelect = qs('#sizeSelect');
    if (sizeSelect) sizeSelect.value = size;
    updateTotal();
  }

  /* ---------- Review ---------- */

  function updateReview() {
    const setText = (id, value) => {
      const el = qs(id);
      if (el) el.textContent = value;
    };
    const toggleRow = (id, show) => {
      const el = qs(id);
      const row = el?.closest('.summary-row');
      if (row) row.hidden = !show;
    };

    setText('#reviewSport', state.sport);
    setText('#reviewTeam', qs('#teamInput')?.value || 'Not selected');
    setText('#reviewBgColour', qs('#bgColourInput')?.value || '—');
    setText('#reviewStyle', qs('#styleInput')?.value || '—');
    setText('#reviewDadName', qs('#dadNameInput')?.value || '—');
    setText('#reviewBackground', qs('#backgroundInput')?.value || '—');
    setText('#reviewSong', qs('#teamSong')?.checked ? 'Included' : 'Not included');
    setText('#reviewPeople', String(state.people));
    setText('#reviewTitle', qs('#posterTitleInput')?.value || 'Untitled poster');
    setText('#reviewYear', qs('#estYear')?.value || '—');
    setText('#reviewMessage', qs('#messageInput')?.value || '—');
    setText('#reviewProduct', productLabel());
    setText('#reviewFrame', state.product === 'frame' ? frameLabel() : 'No frame');
    setText(
      '#reviewSize',
      state.product === 'digital'
        ? 'Digital file'
        : state.size
          ? state.size.replace('x', ' × ').replace('cm', ' cm')
          : '—'
    );
    if (state.product === 'digital') {
      setText('#reviewSizeLabel', 'Size');
    } else {
      updateSizeSectionCopy();
    }

    const teamKey = cfg.teamKey || root.dataset.teamKey;
    const showTeam =
      !!(qs('#teamInput') || isFieldActive(teamKey) || isFieldActive('rugby_team') || isFieldActive('afl_team') || isFieldActive('football_team'));
    toggleRow('#reviewSport', showTeam);
    toggleRow('#reviewTeam', showTeam);
    toggleRow('#reviewBgColour', isFieldActive('bg_colour'));
    toggleRow('#reviewStyle', isFieldActive('style'));
    toggleRow('#reviewDadName', isFieldActive('dad_name'));
    toggleRow('#reviewBackground', isFieldActive('stadium'));
    toggleRow('#reviewSong', isFieldActive('team_song'));
    toggleRow('#reviewTitle', isFieldActive('names'));
    toggleRow('#reviewYear', isFieldActive('est'));
    toggleRow('#reviewMessage', isFieldActive('message') && !!String(qs('#messageInput')?.value || '').trim());

    updateBreakdown();
  }

  function updateBreakdown() {
    const holder = qs('#breakdownRows');
    if (!holder) return;
    const v = currentVariant();
    const shippingFree = cfg.shippingFree !== false;
    const rows = [
      [productLabel(), Number(v?.price) || 0],
      state.product === 'frame' ? [`${frameLabel()} frame`, 0] : null,
      state.product !== 'digital' && state.size
        ? [`Size ${state.size.replace('x', ' × ').replace('cm', ' cm')}`, 0]
        : null,
      state.rush ? ['Rush production', 0] : null,
      state.product === 'digital'
        ? null
        : ['Shipping', shippingFree ? 'Free' : 'Calculated at checkout'],
    ].filter(Boolean);
    holder.innerHTML = rows
      .map(([label, priceOrText], index) => {
        let amount;
        if (typeof priceOrText === 'string') {
          amount = priceOrText;
        } else if (index === 0) {
          amount = moneyCents(priceOrText);
        } else if (priceOrText) {
          amount = moneyCents(priceOrText);
        } else {
          amount = 'Included';
        }
        return `<div class="summary-row"><span>${label}</span><strong>${amount}</strong></div>`;
      })
      .join('');
  }

  /* ---------- Shopify form sync ---------- */

  function syncHiddenFields() {
    const set = (id, value) => {
      const el = qs(id);
      if (el) el.value = value ?? '';
    };
    const matched = currentVariant();
    state.variantId = matched?.id || state.variantId;

    set('#propSport', state.sport);
    set('#propPeople', String(state.people));
    set('#propTeam', qs('#teamInput')?.value || '');
    set('#propBackground', qs('#backgroundInput')?.value || '');
    const songChecked = !!qs('#teamSong')?.checked;
    set('#propTeamSong', songChecked ? 'Yes' : 'No');
    const songValue = qs('#teamSongValue');
    if (songValue) songValue.value = songChecked ? 'Yes' : 'No';
    set('#propNames', qs('#posterTitleInput')?.value || '');
    set('#propEst', qs('#estYear')?.value || '');
    set('#propMessage', qs('#messageInput')?.value || '');
    set('#propProductType', productLabel());
    set('#propFrame', state.product === 'frame' ? frameLabel() : 'No frame');
    set('#propSize', state.product === 'digital' ? 'Digital' : state.size);
    set('#propRush', state.rush ? rushValueForState() : cfg.defaultRush || 'No thanks');
    set('#propPhotoName', state.photoName || '');
    set('#propUploadedImageUrl', state.photoCdnUrl || '');

    const variantInput = qs('#variantIdInput');
    if (variantInput && state.variantId) variantInput.value = state.variantId;
  }

  function buildCartProperties() {
    const teamProperty = cfg.teamProperty || root.dataset.teamProperty || 'Team';
    const namesProperty = cfg.namesProperty || 'Names (ie. Daddy and Clara)';
    const estProperty = cfg.estProperty || 'EST Date (date became a Father) or put N/A';
    const messageProperty = cfg.messageProperty || 'Special message for Dad';
    const dadNameProperty = cfg.dadNameProperty || 'Name for Dad (ie. Dad, Daddy, Grandpa)';

    const properties = {
      Sport: state.sport,
    };

    if (qs('#teamInput') && teamProperty) {
      properties[teamProperty] = qs('#teamInput').value || '';
    }
    if (isFieldActive('stadium')) {
      properties.Background = qs('#backgroundInput')?.value || '';
    }
    if (isFieldActive('bg_colour')) {
      properties['Background colour'] = qs('#bgColourInput')?.value || '';
    }
    if (isFieldActive('style')) {
      properties.Style = qs('#styleInput')?.value || '';
    }
    if (isFieldActive('dad_name')) {
      properties[dadNameProperty] = qs('#dadNameInput')?.value || '';
    }
    if (isFieldActive('team_song') && qs('#teamSong')) {
      properties['Include the team song?'] = qs('#teamSong').checked ? 'Yes' : 'No';
    }
    if (isFieldActive('names')) {
      properties[namesProperty] = qs('#posterTitleInput')?.value || '';
    }
    if (isFieldActive('est')) {
      properties[estProperty] = qs('#estYear')?.value || '';
    }
    if (isFieldActive('message')) {
      properties[messageProperty] = qs('#messageInput')?.value || '';
    }

    // Restored CDN photo → line property until user replaces with a new file upload
    if (!state.photoFile && state.photoCdnUrl) {
      properties['Uploaded image'] = state.photoCdnUrl;
    }

    // Hide Sport for dad poster / non-team products
    if (!qs('#teamInput') && !isFieldActive('rugby_team') && !isFieldActive('afl_team') && !isFieldActive('football_team')) {
      delete properties.Sport;
    }

    Object.keys(properties).forEach((k) => {
      if (!properties[k]) delete properties[k];
    });
    return properties;
  }

  async function addToCart({ checkout = false } = {}) {
    const check = validateStep(3);
    if (!check.ok) {
      if (check.goTo) setStep(check.goTo, { skipValidation: true });
      showStepErrors(check.goTo || state.step, check.errors, check.firstInvalid);
      return;
    }

    syncHiddenFields();
    const properties = buildCartProperties();
    const variantId = state.variantId;
    if (!variantId) {
      showToast(FIELD_LABELS.variant);
      return;
    }
    const cartBtn = qs('#addToCart');
    const shopBtn = qs('#shopNow');
    const shopBtnHtml = shopBtn ? shopBtn.innerHTML : '';

    if (cartBtn) {
      cartBtn.disabled = true;
      if (!checkout) cartBtn.textContent = 'Adding…';
    }
    if (shopBtn) {
      shopBtn.disabled = true;
      if (checkout) shopBtn.textContent = 'Redirecting…';
    }

    const rootPath = window.Shopify?.routes?.root || '/';
    const cartUrl = `${rootPath}cart/add.js`;
    const checkoutUrl = `${rootPath}checkout`;
    const cartPageUrl = `${rootPath}cart`;

    try {
      let res;
      const file = state.photoFile || window.__cocoUploadedFile || qs('#photoUpload')?.files?.[0];
      if (file) {
        // New photo — Shopify stores file on CDN as line-item property
        const fd = new FormData();
        fd.append('id', String(variantId));
        fd.append('quantity', '1');
        Object.entries(properties).forEach(([key, value]) => {
          if (key === 'Uploaded image') return;
          fd.append(`properties[${key}]`, value);
        });
        fd.append('properties[Uploaded image]', file, file.name || 'upload.jpg');
        res = await fetch(cartUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: fd,
        });
      } else {
        // Restored design — properties already include Uploaded image CDN URL
        res = await fetch(cartUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties }),
        });
      }

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Could not add to cart');
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (typeof window.refreshCart === 'function') window.refreshCart();

      if (checkout) {
        showToast('Taking you to checkout…');
        window.location.href = checkoutUrl;
        return;
      }

      showToast(`Added to cart — ${moneyCents(totalCents())}`);
      setTimeout(() => {
        window.location.href = cartPageUrl;
      }, 700);
    } catch (err) {
      showToast(err.message || 'Add to cart failed. Please try again.');
      if (cartBtn) {
        cartBtn.disabled = false;
        cartBtn.innerHTML = 'Add to cart';
      }
      if (shopBtn) {
        shopBtn.disabled = false;
        shopBtn.innerHTML = shopBtnHtml || 'Buy now';
      }
    } finally {
      if (!checkout) {
        if (cartBtn) {
          cartBtn.disabled = false;
          cartBtn.innerHTML = 'Add to cart';
        }
        if (shopBtn) shopBtn.disabled = false;
      }
    }
  }

  /* ---------- Gallery ---------- */

  function initGallery() {
    const mainArtStage = qs('#mainArtStage');
    const mainArtVideo = qs('#mainArtVideo');
    const mainArtImage = qs('#mainArtImage');
    const mainArtImageNext = qs('#mainArtImageNext');
    const galleryThumbs = qsa('#thumbRow .thumb');
    if (!mainArtStage || !galleryThumbs.length) return;

    let currentIndex = Math.max(0, galleryThumbs.findIndex((t) => t.classList.contains('active')));
    let animating = false;
    const ANIM_MS = 380;

    function scrollThumbIntoView(thumb) {
      if (!thumb || typeof thumb.scrollIntoView !== 'function') return;
      thumb.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
    }

    function applyImageSources(img, thumb, alt) {
      if (!img || !thumb) return;
      const src = thumb.dataset.src;
      if (!src) return;
      img.src = src;
      if (thumb.dataset.srcset) img.srcset = thumb.dataset.srcset;
      else img.removeAttribute('srcset');
      if (thumb.dataset.sizes) img.sizes = thumb.dataset.sizes;
      else img.removeAttribute('sizes');
      if (alt != null) img.alt = alt;
    }

    function prefetchThumb(thumb) {
      if (!thumb || thumb.dataset.type === 'video' || !thumb.dataset.src) return;
      if (thumb.dataset.prefetched === '1') return;
      thumb.dataset.prefetched = '1';
      const img = new Image();
      if (thumb.dataset.srcset) img.srcset = thumb.dataset.srcset;
      if (thumb.dataset.sizes) img.sizes = thumb.dataset.sizes;
      img.src = thumb.dataset.src;
    }

    function finishImageSwap(thumb, alt) {
      applyImageSources(mainArtImage, thumb, alt);
      if (mainArtImageNext) {
        mainArtImageNext.removeAttribute('src');
        mainArtImageNext.removeAttribute('srcset');
        mainArtImageNext.removeAttribute('sizes');
        mainArtImageNext.alt = '';
      }
      mainArtStage.classList.remove('is-animating', 'slide-next', 'slide-prev');
      animating = false;
      prefetchThumb(galleryThumbs[(currentIndex + 1) % galleryThumbs.length]);
      prefetchThumb(galleryThumbs[(currentIndex - 1 + galleryThumbs.length) % galleryThumbs.length]);
    }

    function showGalleryItem(index, opts = {}) {
      const nextIndex = (index + galleryThumbs.length) % galleryThumbs.length;
      if (nextIndex === currentIndex && !opts.force) return;
      if (animating) return;

      const thumb = galleryThumbs[nextIndex];
      const prevIndex = currentIndex;
      const direction = opts.direction
        || (nextIndex > prevIndex || (prevIndex === galleryThumbs.length - 1 && nextIndex === 0)
          ? 'next'
          : 'prev');

      // Shortest-path wrap direction for ends
      let slideDir = direction;
      if (!opts.direction) {
        const forward = (nextIndex - prevIndex + galleryThumbs.length) % galleryThumbs.length;
        const backward = (prevIndex - nextIndex + galleryThumbs.length) % galleryThumbs.length;
        slideDir = forward <= backward ? 'next' : 'prev';
      }

      galleryThumbs.forEach((t) => t.classList.toggle('active', t === thumb));
      scrollThumbIntoView(thumb);
      currentIndex = nextIndex;

      if (thumb.dataset.type === 'video') {
        mainArtStage.classList.remove('show-image', 'is-animating', 'slide-next', 'slide-prev');
        if (mainArtVideo) {
          if (thumb.dataset.src && mainArtVideo.getAttribute('src') !== thumb.dataset.src) {
            mainArtVideo.src = thumb.dataset.src;
          }
          mainArtVideo.play().catch(() => {});
        }
        return;
      }

      if (mainArtVideo) mainArtVideo.pause();

      const wasShowingImage = mainArtStage.classList.contains('show-image');
      mainArtStage.classList.add('show-image');

      const alt = thumb.getAttribute('aria-label') || '';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const canAnimate =
        wasShowingImage &&
        !reduceMotion &&
        !opts.force &&
        mainArtImage &&
        mainArtImageNext &&
        !!mainArtImage.getAttribute('src');

      if (!canAnimate) {
        applyImageSources(mainArtImage, thumb, alt);
        mainArtStage.classList.remove('is-animating', 'slide-next', 'slide-prev');
        prefetchThumb(galleryThumbs[(currentIndex + 1) % galleryThumbs.length]);
        return;
      }

      animating = true;
      applyImageSources(mainArtImageNext, thumb, alt);

      const start = () => {
        mainArtStage.classList.add('is-animating', slideDir === 'next' ? 'slide-next' : 'slide-prev');
        window.setTimeout(() => finishImageSwap(thumb, alt), ANIM_MS);
      };

      if (mainArtImageNext.complete) start();
      else mainArtImageNext.onload = start;
    }

    galleryThumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showGalleryItem(index));
    });
    qs('#galleryPrev')?.addEventListener('click', () =>
      showGalleryItem(currentIndex - 1, { direction: 'prev' })
    );
    qs('#galleryNext')?.addEventListener('click', () =>
      showGalleryItem(currentIndex + 1, { direction: 'next' })
    );

    // Warm the next slide after first paint
    requestAnimationFrame(() => {
      prefetchThumb(galleryThumbs[(currentIndex + 1) % galleryThumbs.length]);
    });
  }

  /* ---------- Tabs ---------- */

  function initTabs() {
    qsa('#productTabs .tab-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.tab;
        qsa('#productTabs .tab-btn').forEach((b) => {
          const on = b === btn;
          b.classList.toggle('active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        qsa('#productTabs .tab-panel').forEach((panel) => {
          const on = panel.id === `tab-${tab}`;
          panel.classList.toggle('active', on);
          panel.hidden = !on;
        });
      });
    });
  }

  /* ---------- Save modal / preview cancel ---------- */

  function updateSaveLaterButton() {
    const btn = qs('#saveLater');
    if (!btn) return;
    const isCancel = !!state.previewMode;
    btn.textContent = isCancel ? PREVIEW_CANCEL_LABEL : SAVE_LATER_LABEL;
    btn.setAttribute('aria-label', isCancel ? 'Cancel and return to product page' : 'Save for later');
    root.classList.toggle('preview-mode', isCancel);
  }

  function setPreviewMode(enabled) {
    state.previewMode = !!enabled;
    updateSaveLaterButton();
  }

  function cancelPreviewMode() {
    clearStepErrors(1);
    clearStepErrors(2);
    clearStepErrors(3);
    closeWizard();
  }

  function initSaveModal() {
    const saveModal = qs('#saveModal');
    if (!saveModal) return;

    function openSaveModal() {
      saveModal.classList.remove('success');
      saveModal.classList.add('open');
      saveModal.setAttribute('aria-hidden', 'false');
      qs('#saveName')?.focus();
    }

    function closeSaveModal() {
      saveModal.classList.remove('open');
      saveModal.setAttribute('aria-hidden', 'true');
    }

    function handleSaveLaterClick() {
      if (state.previewMode) {
        cancelPreviewMode();
        return;
      }
      openSaveModal();
    }

    qs('#saveLater')?.addEventListener('click', handleSaveLaterClick);
    qs('#closeSaveModal')?.addEventListener('click', closeSaveModal);
    qs('#doneSaveModal')?.addEventListener('click', closeSaveModal);
    saveModal.addEventListener('click', (e) => {
      if (e.target === saveModal) closeSaveModal();
    });

    updateSaveLaterButton();

    // Submit / API handled by coco-daddy-save-later.js
  }

  function getPublicState() {
    return {
      step: state.step,
      sport: state.sport,
      people: state.people,
      photoName: state.photoName,
      photoData: state.photoData,
      photoFile: state.photoFile,
      photoCdnUrl: state.photoCdnUrl,
      frame: state.frame,
      product: state.product,
      size: state.size,
      rush: state.rush,
      variantId: state.variantId,
      fields: {
        team: qs('#teamInput')?.value || '',
        stadium: qs('#backgroundInput')?.value || '',
        bg_colour: qs('#bgColourInput')?.value || '',
        style: qs('#styleInput')?.value || '',
        dad_name: qs('#dadNameInput')?.value || '',
        team_song: qs('#teamSong')?.checked ? 'Yes' : 'No',
        names: qs('#posterTitleInput')?.value || '',
        est: qs('#estYear')?.value || '',
        message: qs('#messageInput')?.value || '',
      },
    };
  }

  function applySavedDesign(design, { goToReview = true, openWizard: shouldOpen = true, previewMode = false } = {}) {
    if (!design || typeof design !== 'object') return false;

    const fields = design.fields || {};
    const framing = design.framing || {};
    const photo = design.photo || null;
    const teamKey = cfg.teamKey || 'team';

    const teamVal =
      fields[teamKey] ||
      fields.rugby_team ||
      fields.afl_team ||
      fields.football_team ||
      fields.team ||
      '';
    const teamInput = qs('#teamInput');
    if (teamInput && teamVal) teamInput.value = teamVal;

    const stadium = fields.stadium || fields.background || '';
    const bgInput = qs('#backgroundInput');
    if (bgInput && stadium) bgInput.value = stadium;
    if (stadium) {
      qsa('#stadiumOptions .choice-btn').forEach((btn) => {
        btn.classList.toggle('active', btn.dataset.bg === stadium);
      });
    }

    const bgColour = fields.bg_colour || fields.background_colour || '';
    const bgColourInput = qs('#bgColourInput');
    if (bgColourInput && bgColour) {
      bgColourInput.value = bgColour;
      qsa('#bgColourOptions .bg-colour-chip').forEach((chip) => {
        chip.classList.toggle('active', chip.dataset.bgColour === bgColour);
      });
    }

    const styleVal = fields.style || '';
    const styleInput = qs('#styleInput');
    if (styleInput && styleVal) {
      styleInput.value = styleVal;
      qsa('#styleOptions .choice-btn').forEach((btn) => {
        btn.classList.toggle('active', btn.dataset.style === styleVal);
      });
    }

    const dadName = fields.dad_name || '';
    const dadNameInput = qs('#dadNameInput');
    if (dadNameInput && dadName) dadNameInput.value = dadName;

    const song = fields.team_song;
    const songEl = qs('#teamSong');
    if (songEl && song != null) {
      songEl.checked = String(song).toLowerCase() === 'yes' || song === true;
    }

    const names = fields.names || fields.title || '';
    const namesInput = qs('#posterTitleInput');
    if (namesInput && names) namesInput.value = names;

    const est = fields.est || fields.est_year || '';
    const estInput = qs('#estYear');
    if (estInput && est) estInput.value = est;

    const message = fields.message || '';
    const messageInput = qs('#messageInput');
    if (messageInput && message) messageInput.value = message;

    if (framing.people) {
      state.people = String(framing.people);
      qsa('.people-btn').forEach((b) =>
        b.classList.toggle('active', b.dataset.people === String(framing.people))
      );
    }

    if (framing.rush != null) {
      state.rush = !!framing.rush;
      const rushToggle = qs('#rushToggle');
      if (rushToggle) rushToggle.checked = state.rush;
    }

    const product = framing.product || '';
    const size = framing.size || '';
    let frame = framing.frame || '';
    if (product && product !== 'frame') frame = 'none';

    if (product && isProductTypeAvailable(product)) {
      setProduct(product);
      if (product !== 'digital' && size && isSizeAvailable(size)) setSize(size);
      if (product === 'frame' && frame && isFrameColourAvailable(frame)) setFrame(frame);
      else if (product !== 'frame') setFrame('none');
    }
    if (photo?.url && /^https?:\/\//i.test(photo.url)) {
      applyPhoto(photo.url, photo.name || 'saved-photo.jpg', null);
    } else if (photo?.dataUrl) {
      applyPhoto(photo.dataUrl, photo.name || 'saved-photo.jpg', null);
    } else if (fields.upload && typeof fields.upload === 'string') {
      if (/^https?:\/\//i.test(fields.upload)) {
        applyPhoto(fields.upload, 'saved-photo.jpg', null);
      } else if (fields.upload.startsWith('data:')) {
        applyPhoto(fields.upload, 'saved-photo.jpg', null);
      }
    }

    syncHiddenFields();
    updateTotal();

    if (shouldOpen) openWizard();
    if (goToReview) {
      setStep(3, { skipValidation: true });
      updateReview();
    } else {
      setStep(1, { skipValidation: true });
    }

    if (previewMode) setPreviewMode(true);

    return true;
  }

  function setPhotoRemoteUrl(url, name) {
    if (!url || !/^https?:\/\//i.test(String(url))) return;
    applyPhoto(url, name || state.photoName || 'saved-photo.jpg', null);
  }

  function isShopifyImageUrl(value) {
    const val = String(value || '').trim();
    if (!/^https?:\/\//i.test(val)) return false;
    if (/fakepath/i.test(val)) return false;
    return (
      /cdn\.shopify\.com/i.test(val) ||
      /\/uploads\//i.test(val) ||
      /\.(jpe?g|png|gif|webp|heic)(\?|$)/i.test(val)
    );
  }

  function extractUploadedImageUrl(item) {
    if (!item) return '';
    const props = item.properties || {};
    const candidates = [props['Uploaded image'], props['Uploaded Image'], props.upload];
    return candidates.find(isShopifyImageUrl) || '';
  }

  async function fileFromPhotoState() {
    const file = state.photoFile || window.__cocoUploadedFile || qs('#photoUpload')?.files?.[0];
    if (file) return file;
    const data = state.photoData || '';
    if (typeof data === 'string' && data.startsWith('data:')) {
      const res = await fetch(data);
      const blob = await res.blob();
      return new File([blob], state.photoName || 'upload.jpg', {
        type: blob.type || 'image/jpeg',
      });
    }
    return null;
  }

  /**
   * Upload local photo via Shopify cart file property, return CDN URL, remove temp line.
   * Used by save-for-later before POST /save-for-dad-poster (JSON body).
   */
  async function uploadPhotoForSave() {
    if (state.photoCdnUrl && isShopifyImageUrl(state.photoCdnUrl)) return state.photoCdnUrl;
    if (state.photoData && isShopifyImageUrl(state.photoData)) return state.photoData;

    const file = await fileFromPhotoState();
    if (!file) return '';

    displayVariant();
    const variantId = state.variantId;
    if (!variantId) throw new Error('Product variant not ready. Please try again.');

    const rootPath = window.Shopify?.routes?.root || '/';
    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    fd.append('properties[Uploaded image]', file, file.name || 'upload.jpg');

    const addRes = await fetch(`${rootPath}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: fd,
    });
    const addData = await addRes.json().catch(() => null);
    if (!addRes.ok) {
      throw new Error(
        addData?.description || addData?.message || 'Could not upload photo to Shopify.'
      );
    }

    let url = extractUploadedImageUrl(addData);
    const lineKey = addData.key || addData.items?.[0]?.key;

    if (!url) {
      const cartRes = await fetch(`${rootPath}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      const cart = await cartRes.json().catch(() => null);
      const items = cart?.items || [];
      const match =
        (lineKey && items.find((it) => it.key === lineKey)) || items[items.length - 1];
      url = extractUploadedImageUrl(match);
    }

    if (lineKey) {
      await fetch(`${rootPath}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
      }).catch(() => {});
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    if (!url) {
      throw new Error('Photo uploaded but Shopify did not return a file URL. Please try again.');
    }

    setPhotoRemoteUrl(url, file.name);
    return url;
  }

  window.CocoDaddyPosterAPI = {
    getState: getPublicState,
    applySavedDesign,
    setPhotoRemoteUrl,
    uploadPhotoForSave,
    setPreviewMode,
    showToast,
    openWizard,
    closeWizard,
    setStep,
    setProduct,
    setSize,
    setFrame,
    updateReview,
    updateTotal,
    PRODUCT_PARAMS_HINT: {
      framing: {
        product: ['digital', 'print', 'frame'],
        size: ['30x40cm', '45x60cm'],
        frame: ['natural', 'black', 'white', 'none'],
      },
    },
  };

  /* ---------- Bind events ---------- */

  function bindUpload() {
    const photoUpload = qs('#photoUpload');
    const uploadBox = qs('#uploadBox');
    if (!photoUpload) return;

    const openPicker = () => {
      try {
        photoUpload.value = '';
      } catch (e) {}
      // Must run from a direct user gesture for Chrome.
      photoUpload.click();
    };

    photoUpload.addEventListener('change', (e) => {
      const file = e.target.files && e.target.files[0];
      if (file) handleFile(file);
    });

    function bindDropZone(box) {
      if (!box) return;
      box.addEventListener('click', (e) => {
        if (e.target.closest('.upload-remove')) return;
        e.preventDefault();
        openPicker();
      });
      ['dragenter', 'dragover'].forEach((eventName) =>
        box.addEventListener(eventName, (e) => {
          e.preventDefault();
          box.classList.add('drag');
        })
      );
      ['dragleave', 'drop'].forEach((eventName) =>
        box.addEventListener(eventName, (e) => {
          e.preventDefault();
          box.classList.remove('drag');
        })
      );
      box.addEventListener('drop', (e) => handleFile(e.dataTransfer.files[0]));
    }

    bindDropZone(uploadBox);

    // Mobile uses <label for="photoUpload"> — native picker (no extra .click()).
    qs('#changePhotoBtn')?.addEventListener('click', (e) => {
      e.preventDefault();
      openPicker();
    });

    qs('#uploadRemove')?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearPhoto();
    });
  }

  function init() {
    setWizardScrollLock(false);

    qs('#startWizard')?.addEventListener('click', openWizard);
    qs('#wizardBackExit')?.addEventListener('click', closeWizard);

    qsa('[data-next]').forEach((btn) =>
      btn.addEventListener('click', () => setStep(Number(btn.dataset.next)))
    );
    qsa('[data-back]').forEach((btn) =>
      btn.addEventListener('click', () => setStep(Number(btn.dataset.back), { skipValidation: true }))
    );

    qsa('.sport-card').forEach((card) =>
      card.addEventListener('click', () => {
        const url = card.dataset.url;
        if (url && url !== window.location.pathname && !card.classList.contains('selected')) {
          window.location.href = url;
          return;
        }
        state.sport = card.dataset.sport;
        qsa('.sport-card').forEach((c) => {
          const selected = c === card;
          c.classList.toggle('selected', selected);
          const em = c.querySelector('em');
          if (em) em.textContent = selected ? 'Selected' : 'Select';
        });
        syncHiddenFields();
      })
    );

    qsa('.people-btn').forEach((btn) =>
      btn.addEventListener('click', () => {
        state.people = String(btn.dataset.people || '').trim();
        qsa('.people-btn').forEach((b) => b.classList.toggle('active', b === btn));
        updateTotal();
      })
    );

    bindUpload();

    qs('#posterTitleInput')?.addEventListener('input', (e) => {
      e.target.classList.remove('is-invalid');
      e.target.closest('.field')?.classList.remove('is-invalid');
      qsa('[data-poster-title]').forEach(
        (el) => (el.textContent = e.target.value.toUpperCase() || 'YOUR TITLE')
      );
      syncHiddenFields();
    });

    qs('#estYear')?.addEventListener('input', (e) => {
      e.target.classList.remove('is-invalid');
      e.target.closest('.field')?.classList.remove('is-invalid');
      const year = e.target.value.trim();
      qsa('[data-poster-subtitle]').forEach(
        (el) => (el.textContent = year ? `EST. ${year}` : '')
      );
      syncHiddenFields();
    });

    qs('#teamInput')?.addEventListener('change', (e) => {
      e.target.classList.remove('is-invalid');
      e.target.closest('.field')?.classList.remove('is-invalid');
      syncHiddenFields();
    });
    qs('#messageInput')?.addEventListener('input', (e) => {
      e.target.classList.remove('is-invalid');
      e.target.closest('.field')?.classList.remove('is-invalid');
      syncHiddenFields();
    });
    qs('#teamSong')?.addEventListener('change', syncHiddenFields);

    qsa('#stadiumOptions .choice-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const name = btn.dataset.bg;
        const bgInput = qs('#backgroundInput');
        if (bgInput) bgInput.value = name;
        qsa('#stadiumOptions .choice-btn').forEach((b) =>
          b.classList.toggle('active', b.dataset.bg === name)
        );
        getFieldWrap('stadium')?.classList.remove('is-invalid');
        syncHiddenFields();
      });
    });

    function selectBgColour(name) {
      const input = qs('#bgColourInput');
      if (input) input.value = name;
      qsa('#bgColourOptions .bg-colour-chip').forEach((c) =>
        c.classList.toggle('active', c.dataset.bgColour === name)
      );
      getFieldWrap('bg_colour')?.classList.remove('is-invalid');
      syncHiddenFields();
    }

    qsa('#bgColourOptions .bg-colour-chip').forEach((chip) => {
      chip.addEventListener('click', () => selectBgColour(chip.dataset.bgColour));
    });

    function openBgColourPreview() {
      const modal = qs('#bgColourPreviewModal');
      const grid = qs('#bgColourPreviewGrid');
      if (!modal || !grid) return;
      const current = qs('#bgColourInput')?.value || '';
      grid.innerHTML = qsa('#bgColourOptions .bg-colour-chip')
        .map((chip) => {
          const name = chip.dataset.bgColour || '';
          const img = chip.dataset.bgImg || '';
          const hex = chip.dataset.bgHex || chip.style.background || '#ece5e1';
          const sel = name === current ? ' sel' : '';
          const media = img
            ? `<img src="${img}" alt="${name}" loading="lazy" />`
            : `<span class="bg-colour-preview-swatch" style="background:${hex}"></span>`;
          return `<button type="button" class="bg-colour-preview-tile${sel}" data-bg-colour="${name}" aria-label="${name}">${media}<span class="nm">${name}</span></button>`;
        })
        .join('');
      grid.querySelectorAll('.bg-colour-preview-tile').forEach((tile) => {
        tile.addEventListener('click', () => {
          selectBgColour(tile.dataset.bgColour);
          closeBgColourPreview();
        });
      });
      modal.hidden = false;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
    }

    function closeBgColourPreview() {
      const modal = qs('#bgColourPreviewModal');
      if (!modal) return;
      modal.classList.remove('open');
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
    }

    qs('#seeBgColourPreview')?.addEventListener('click', openBgColourPreview);
    qs('#closeBgColourPreview')?.addEventListener('click', closeBgColourPreview);
    qs('#bgColourPreviewModal')?.addEventListener('click', (e) => {
      if (e.target === qs('#bgColourPreviewModal')) closeBgColourPreview();
    });

    function selectStyle(name) {
      const input = qs('#styleInput');
      if (input) input.value = name;
      qsa('#styleOptions .choice-btn').forEach((b) =>
        b.classList.toggle('active', b.dataset.style === name)
      );
      getFieldWrap('style')?.classList.remove('is-invalid');
      syncHiddenFields();
    }

    qsa('#styleOptions .choice-btn').forEach((btn) => {
      btn.addEventListener('click', () => selectStyle(btn.dataset.style));
    });

    qs('#dadNameInput')?.addEventListener('input', (e) => {
      e.target.classList.remove('is-invalid');
      e.target.closest('.field')?.classList.remove('is-invalid');
      syncHiddenFields();
    });

    qsa('.frame-card').forEach((card) =>
      card.addEventListener('click', () => {
        if (card.classList.contains('is-unavailable') || !isFrameColourAvailable(card.dataset.frame)) {
          showToast('Not available');
          return;
        }
        setFrame(card.dataset.frame);
      })
    );

    qsa('#productTypes .product-type').forEach((btn) =>
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-unavailable') || !isProductTypeAvailable(btn.dataset.product)) {
          showToast('Not available');
          return;
        }
        setProduct(btn.dataset.product);
      })
    );

    qsa('#sizeOptions .size-btn').forEach((btn) =>
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-unavailable') || !isSizeAvailable(btn.dataset.size)) {
          showToast('Not available');
          return;
        }
        setSize(btn.dataset.size);
      })
    );

    qs('#rushToggle')?.addEventListener('change', (e) => {
      state.rush = e.target.checked;
      updateTotal();
    });

    qs('#addToCart')?.addEventListener('click', () => addToCart({ checkout: false }));
    qs('#shopNow')?.addEventListener('click', () => addToCart({ checkout: true }));

    // No default framing selection — user must choose product / size / frame
    const sizeSection = qs('#sizeSection');
    const frameSection = qs('#frameColourSection');
    if (sizeSection) sizeSection.hidden = true;
    if (frameSection) frameSection.hidden = true;
    initTabs();
    initGallery();
    initSaveModal();
    updateTotal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
